import React, { Component, Fragment } from 'react';
import { Col, Form, Row, Button, Table, Container, Jumbotron } from 'react-bootstrap';
import config from '../../../config';
import { CSVLink } from "react-csv";
import errores from '../../../middleware/errordb';
import Menu from '../../menu';


export class reporteVentas extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;

        this.state = {
            empresa: currentCompany,
            tipo_documento: "%",
            fecha_inicial: todayFormat,
            fecha_final: todayFormat,
            resoluciones: [],
            infoReporte: []
        }

    }

    componentDidMount() {
        const { empresa } = this.state
        const { tipo } = this.state
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': empresa,
                'tipo': tipo,
            }
        };
        fetch(config.servBackEnd + '/resoluciones/', datasend)
            .then(res => res.json())
            .then((data) => {
                /* const tmpResoluciones = []
                data.forEach(element => {
                    if (element.TIPO_DOCUMENTO === "PS") tmpResoluciones.push(element);
                }); */
                this.setState({ resoluciones: data });

            })
            .catch((error) => console.error(error))
    }

    initReporte = (event) => {
        event.preventDefault();
        const { empresa } = this.state;
        const { fecha_inicial } = this.state;
        const { fecha_final } = this.state;
        const { tipo_documento } = this.state;

        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                empresa,
                fecha_inicial,
                fecha_final,
                tipo_documento
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
                'empresa': empresa
            }
        }
        fetch(config.servBackEnd + '/reports/ventasposdoc', datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const info = data.data[0]
                    this.setState({ infoReporte: info });
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Ingreso con errores:" + errores[data.code] + " " + data.message })
                }
            });
    }

    calcTotales=()=>{
        const {infoReporte} = this.state;
        const totales={
            sumBruto:0,
            sumIva:0,
            sumNeto:0
        }
        infoReporte.forEach(element => {
            totales.sumBruto += parseFloat(element.TOTAL_BRUTO);
            totales.sumIva += parseFloat(element.TOTAL_IVA);
            totales.sumNeto += parseFloat(element.TOTAL_VENTA);
        });

        return totales;
    }


    render() {
        const { resoluciones } = this.state;
        const { infoReporte } = this.state;
        const totales = this.calcTotales();
        return (
            <Fragment>
                <Menu></Menu>
                <Jumbotron className="Jumbotron">
                    <h2>Reporte de ventas POS por documento</h2>
                </Jumbotron>
                <Container fluid>
                    <Form onSubmit={this.initReporte}>
                        <Row className="justify-content-md-center" >
                            <Col className="mb-2" xs={5} lg={1}>FECHA INICIO</Col>
                            <Col className="mb-2" xs={7} lg={2}>
                                <Form.Control type="date" onChange={e => this.setState({ fecha_inicial: e.target.value })} value={this.state.fecha_inicial} required />
                            </Col>
                            <Col className="mb-2" xs={5} lg={1}>FECHA FIN</Col>
                            <Col className="mb-2" xs={7} lg={2}>
                                <Form.Control type="date" onChange={e => this.setState({ fecha_final: e.target.value })} value={this.state.fecha_final} required />
                            </Col>
                            <Col className="mb-2" xs={5} lg={1}>TIPO</Col>
                            <Col className="mb-2" xs={7} lg={1}>
                                <Form.Control as="select" onChange={e => this.setState({ tipo_documento: e.target.value })} value={this.state.tipo_documento} >
                                    <option value="%"></option>
                                    {
                                        resoluciones.map((resoluion, i) => {
                                            return <option key={'td' + i} value={resoluion.PREFIJO}>{resoluion.PREFIJO}</option>;
                                        })
                                    }
                                </Form.Control>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Button type="submit" className="m-3" name="actualizar" >Generar Reporte</Button>
                                <CSVLink data={infoReporte} filename={"INVENTARIO.csv"} separator={";"}>
                                    <Button disabled={infoReporte.length === 0} variant="success">Descargar Reporte</Button>
                                </CSVLink>
                                {/* <Button disabled={this.state.tipo_reporte === ""} onClick={this.initReporte} className="m-3" name="descargar" ></Button> */}
                            </Col>
                        </Row>
                    </Form>
                </Container>
                <Container>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <td>FECHA DOCUMENTO</td>
                                <td>DOCUMENTO</td>
                                <td>NUMERO</td>
                                <td>BRUTO</td>
                                <td>IVA</td>
                                <td>NETO</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                infoReporte.map((element, i) => {
                                    return (<tr key={'tr' + i}>
                                        <td>{element.FECHA_DOCUMENTO}</td>
                                        <td>{element.TIPO_DOCUMENTO_CABECERA}</td>
                                        <td>{element.NUMERO_FACTURA_CABECERA }</td>
                                        <td className="currSign">{ Intl.NumberFormat('es-MX').format(element.TOTAL_BRUTO) }</td>
                                        <td className="currSign">{ Intl.NumberFormat('es-MX').format(element.TOTAL_IVA) }</td>
                                        <td className="currSign">{ Intl.NumberFormat('es-MX').format(element.TOTAL_VENTA) }</td>
                                    </tr>);
                                })
                            }
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="3"></td>
                                <td className="currSign">{ Intl.NumberFormat('es-MX').format( totales.sumBruto)  }</td>
                                <td className="currSign">{ Intl.NumberFormat('es-MX').format( totales.sumIva)  }</td>
                                <td className="currSign">{ Intl.NumberFormat('es-MX').format( totales.sumNeto)  }</td>
                            </tr>
                        </tfoot>
                    </Table>
                </Container>
            </Fragment>
        )
    }
}

export default reporteVentas
